import React from 'react';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { DataList, formatListData } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { actions } from '../../actions/conversions';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { conversionsConfig, DEFAULT_CONFIG } from './conversionsConfig';
import { IOffer } from '../../utils/type';

const useConversions = () => {
	const location = useLocation();
	const getConversionsData = () => {
		const offers = _get(location, ['state', 'rowData', 'offer'])?.withdrawRange?.map((offer: IOffer, index: number) => {
			return {
				startRange: offer?.range?.start,
				endRange: offer?.range?.end,
				totalPercentage: offer?.rewardPercentage?.totalPercentage,
				cashbackPercentage: offer?.rewardPercentage?.cashbackPercentage,
				bonusPercentage: offer?.rewardPercentage?.bonusPercentage,
				totalFlatValue: offer?.rewardFlatValue?.totalFlatValue,
				cashbackFlatValue: offer?.rewardFlatValue?.cashbackFlatValue,
				bonusFlatValue: offer?.rewardFlatValue?.bonusFlatValue,
				index: index + 1
			};
		});
		return { rowCount: offers?.length, data: formatListData(offers) };
	};
	const { getActionHandler } = useDashboardActions(makeActionHandler, makeActionList);
	return { getConversionsData, getActionHandler };
};

const Conversions: React.FC<{}> = () => {
	const { getConversionsData, getActionHandler } = useConversions();
	return (
		<div>
			<DataList
				fetchData={getConversionsData}
				columnConfigs={conversionsConfig}
				defaults={DEFAULT_CONFIG}
				actions={actions}
				getActionHandler={getActionHandler}
				disableColumnFilter
				entity={LIST_ENTITY_NAMES.CTD_OFFERS}
			/>
		</div>
	);
};

export default Conversions;
